import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { AuthService } from "../../app/auth/auth.service";
import { StateManagementService } from "../../providers/state-management/state-management.service";
import { ProfessionalProvidersListPage } from "./professional-providers-list/professional-providers-list";

@IonicPage()
@Component({
  selector: "company-providers",
  templateUrl: "company-resources.html",
})
export class CompanyResourcesPage {
  rootPage: ProfessionalProvidersListPage;

  constructor(
    // AuthService was injected TWICE (as `authService`, never used, and again as
    // `authSvc`). Angular hands back the same singleton for both, so the duplicate
    // only made it ambiguous which name to reach for; it is now one field (CO-3352).
    private stateManagement: StateManagementService,
    private navCtrl: NavController,
    private authSvc: AuthService
  ) {}

  ionViewDidLoad() {
    this.stateManagement.setAssessmentType("company-resources");
    this.stateManagement.setSectionId("Providers");
  }

  ionViewCanEnter() {
    return this.authSvc.isAuthenticated();
  }

  navigate(entity: string) {
    this.navCtrl.push("CompanyResourcesListPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-resources/company-resources.ts